module.exports = "./img/25ba12c7f9bcd5be4986bb9990ee266a.jpg";